"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "AnomaliesGroupingSettingsSk", {
    enumerable: true,
    get: function() {
        return AnomaliesGroupingSettingsSk;
    }
});
const _lit = require("lit");
const _decorators = require("lit/decorators.js");
require("../../../elements-sk/modules/icons/help-icon-sk");
const _grouping = require("./grouping");
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
let AnomaliesGroupingSettingsSk = class AnomaliesGroupingSettingsSk extends _lit.LitElement {
    createRenderRoot() {
        return this;
    }
    render() {
        if (!this.config) {
            return (0, _lit.html)``;
        }
        const safeId = this.uniqueId || 'default';
        return (0, _lit.html)`
      <details class="grouping-settings">
        <summary>Grouping Settings</summary>
        <div class="grouping-settings-panel">
          <div class="grouping-setting-group">
            <div class="grouping-setting-label">
              <label for="revision-mode-select-${safeId}">Revision Grouping</label>
              <help-icon-sk
                title="Determines how anomalies are grouped based on their commit range.

* Range Overlap: Groups anomalies with overlapping ranges.
* Exact Range: Groups anomalies with exact same ranges.
* Ignore Range: Groups all anomalies into a single group."></help-icon-sk>
            </div>
            <select
              id="revision-mode-select-${safeId}"
              @change=${(e)=>this.onRevisionModeChange(e)}>
              <option value="OVERLAPPING" ?selected=${this.config.revisionMode === 'OVERLAPPING'}>
                Range Overlap
              </option>
              <option value="EXACT" ?selected=${this.config.revisionMode === 'EXACT'}>
                Exact Range
              </option>
              <option value="ANY" ?selected=${this.config.revisionMode === 'ANY'}>
                Ignore Range
              </option>
            </select>
          </div>

          <div class="grouping-setting-group">
            <div class="grouping-setting-label">
              <span>Split Groups By</span>
              <help-icon-sk
                title="Determines more granular group split *after* grouping by revision."></help-icon-sk>
            </div>
            <div class="checkbox-container">
              <label>
                <input
                  type="checkbox"
                  value="BENCHMARK"
                  ?checked=${this.config.groupBy.has('BENCHMARK')}
                  @change=${(e)=>this.onGroupByChange(e, 'BENCHMARK')} />
                Benchmark
              </label>
              <label>
                <input
                  type="checkbox"
                  value="BOT"
                  ?checked=${this.config.groupBy.has('BOT')}
                  @change=${(e)=>this.onGroupByChange(e, 'BOT')} />
                Bot
              </label>
              <label>
                <input
                  type="checkbox"
                  value="TEST"
                  ?checked=${this.config.groupBy.has('TEST')}
                  @change=${(e)=>this.onGroupByChange(e, 'TEST')} />
                Test (without subtests)
              </label>
            </div>
          </div>
        </div>
      </details>
    `;
    }
    onRevisionModeChange(e) {
        const select = e.target;
        this.dispatchEvent(new CustomEvent('revision-mode-change', {
            detail: select.value,
            bubbles: true
        }));
    }
    onGroupByChange(e, criteria) {
        const checkbox = e.target;
        this.dispatchEvent(new CustomEvent('group-by-change', {
            detail: {
                criteria,
                enabled: checkbox.checked
            },
            bubbles: true
        }));
    }
    constructor(...args){
        super(...args);
        this.uniqueId = '';
    }
};
_ts_decorate([
    (0, _decorators.property)({
        attribute: false
    }),
    _ts_metadata("design:type", typeof _grouping.AnomalyGroupingConfig === "undefined" ? Object : _grouping.AnomalyGroupingConfig)
], AnomaliesGroupingSettingsSk.prototype, "config", void 0);
_ts_decorate([
    (0, _decorators.property)({
        type: String
    }),
    _ts_metadata("design:type", String)
], AnomaliesGroupingSettingsSk.prototype, "uniqueId", void 0);
AnomaliesGroupingSettingsSk = _ts_decorate([
    (0, _decorators.customElement)('anomalies-grouping-settings-sk')
], AnomaliesGroupingSettingsSk);
